import { colors } from '@flowio/design-tokens';
var textColor = {
  badge: {
    negative: colors.white,
    neutral: colors.black,
    positive: colors.white,
    primary: colors.white,
    warning: colors.black
  },
  banner: {
    info: colors.white,
    negative: colors.white,
    neutral: colors.black,
    positive: colors.white,
    warning: colors.black
  },
  button: {
    flat: {
      negative: {
        active: colors.red[100],
        base: colors.red[500],
        disabled: colors.neutral[500],
        focused: colors.red[100],
        hover: colors.red[100]
      },
      neutral: {
        active: colors.neutral[800],
        base: colors.neutral[700],
        disabled: colors.neutral[500],
        focused: colors.neutral[700],
        hover: colors.neutral[700]
      },
      positive: {
        active: colors.green[100],
        base: colors.green[500],
        disabled: colors.neutral[500],
        focused: colors.green[100],
        hover: colors.green[100]
      },
      primary: {
        active: colors.blue[100],
        base: colors.blue[500],
        disabled: colors.neutral[500],
        focused: colors.blue[100],
        hover: colors.blue[100]
      },
      warning: {
        active: colors.yellow[100],
        base: colors.yellow[500],
        disabled: colors.neutral[500],
        focused: colors.yellow[100],
        hover: colors.yellow[100]
      }
    },
    outline: {
      negative: {
        active: colors.red[100],
        base: colors.red[500],
        disabled: colors.neutral[500],
        focused: colors.red[100],
        hover: colors.red[100]
      },
      neutral: {
        active: colors.neutral[700],
        base: colors.neutral[700],
        disabled: colors.neutral[500],
        focused: colors.neutral[700],
        hover: colors.neutral[700]
      },
      positive: {
        active: colors.green[100],
        base: colors.green[500],
        disabled: colors.neutral[500],
        focused: colors.green[100],
        hover: colors.green[100]
      },
      primary: {
        active: colors.blue[100],
        base: colors.blue[500],
        disabled: colors.neutral[500],
        focused: colors.blue[100],
        hover: colors.blue[100]
      },
      warning: {
        active: colors.yellow[100],
        base: colors.yellow[500],
        disabled: colors.neutral[500],
        focused: colors.yellow[100],
        hover: colors.yellow[100]
      }
    },
    solid: {
      negative: {
        active: colors.red[100],
        base: colors.red[100],
        disabled: colors.neutral[500],
        focused: colors.red[100],
        hover: colors.red[100]
      },
      neutral: {
        active: colors.neutral[700],
        base: colors.neutral[700],
        disabled: colors.neutral[500],
        focused: colors.neutral[700],
        hover: colors.neutral[700]
      },
      positive: {
        active: colors.green[100],
        base: colors.green[100],
        disabled: colors.neutral[500],
        focused: colors.green[100],
        hover: colors.green[100]
      },
      primary: {
        active: colors.blue[100],
        base: colors.blue[100],
        disabled: colors.neutral[100],
        focused: colors.blue[100],
        hover: colors.blue[100]
      },
      warning: {
        active: colors.yellow[100],
        base: colors.yellow[100],
        disabled: colors.neutral[500],
        focused: colors.yellow[100],
        hover: colors.yellow[100]
      }
    },
    link: {
      base: colors.blue[600],
      disabled: colors.blue[600],
      active: colors.blue[700],
      focused: colors.blue[600],
      hover: colors.blue[600]
    }
  },
  tabButton: {
    base: colors.neutral[900]
  },
  floatingLabel: {
    neutral: {
      active: colors.neutral[700],
      base: colors.neutral[700],
      disabled: colors.neutral[500],
      focused: colors.neutral[900]
    },
    negative: {
      active: colors.red[600],
      base: colors.neutral[700],
      disabled: colors.neutral[500],
      focused: colors.neutral[900]
    },
    positive: {
      active: colors.green[500],
      base: colors.neutral[700],
      disabled: colors.neutral[500],
      focused: colors.neutral[900]
    },
    warning: {
      active: colors.yellow[500],
      base: colors.neutral[700],
      disabled: colors.neutral[500],
      focused: colors.neutral[900]
    }
  },
  floatingLabelInput: {
    clearIndicator: colors.neutral[900],
    control: {
      disabled: colors.neutral[700],
      base: colors.neutral[900]
    },
    icon: {
      base: colors.neutral[700],
      disabled: colors.neutral[600],
      negative: colors.red[500],
      positive: colors.green[500],
      warning: colors.yellow[500]
    }
  },
  menuItem: {
    active: colors.white,
    base: '#4D5866',
    disabled: '#B5BEC9'
  }
};
export default textColor;